// extracted by mini-css-extract-plugin
export default {"button":"CmsButton-module__button-l0KD5p"};